import { useReexecuteQueryWhenInputsChange, useSecureGraphqlQuery } from '@psyomics/ui-common';
import { useMemo } from 'react';

import {
  GetReferralUploadJobsDocument,
  GetReferralUploadJobsQuery,
  GetReferralUploadJobsQueryVariables,
} from './generated/referral-upload-jobs';

type UseReferralUploadJobsQueryInput = {
  pageIndex: number;
  pageSize: number;
};

const useReferralUploadJobsQuery = ({ pageIndex, pageSize }: UseReferralUploadJobsQueryInput) => {
  const queryInput = useMemo(
    () => ({
      query: GetReferralUploadJobsDocument,
      pause: true,
      variables: {
        input: {
          pagedQuery: { offset: pageIndex * pageSize, pageSize },
        },
      },
    }),
    [pageIndex, pageSize]
  );

  const [{ data, fetching }, reexecuteQuery] = useSecureGraphqlQuery<
    GetReferralUploadJobsQuery,
    GetReferralUploadJobsQueryVariables
  >(queryInput);

  useReexecuteQueryWhenInputsChange(reexecuteQuery, queryInput);

  const result = data?.getReferralUploadJobs;
  return { result, fetching };
};

export { useReferralUploadJobsQuery };
